// extracted by mini-css-extract-plugin
export default {"alertBox":"styles_alertBox__4Lrql"};